import { RefreshCcw } from 'lucide-react';
import { useState } from 'react';

type Props = {
  disabled?: boolean;
  className?: string;
};

export default function DateTimeInput({ disabled, className }: Props) {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const reset = () => {
    setDate('');
    setTime('');
  };

  return (
    <div className="flex items-center gap-2 w-full">
      <div className="flex gap-2 w-full">
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          disabled={disabled}
          className={className}
        />

        <input
          type="time"
          value={time}
          onChange={(e) => setTime(e.target.value)}
          disabled={disabled}
          className={className}
        />
      </div>

      <button type="button" onClick={reset} className="text-[#7a3a4c]">
        <RefreshCcw size={18} />
      </button>
    </div>
  );
}
